import React from "react"
import { cn } from "~/ui-rtk/utils/tailwind-utils"
export type CheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  className?: string
  checked?: boolean
}

export default function Checkbox({
  className,
  checked = false,
  onChange,
  ...rest
}: CheckboxProps) {
  const defaultClassNames =
    "rounded-sm cursor-pointer checked:outline-none focus:outline-none focus:ring-offset-0 focus:ring-0 appearance-none"
  const cx = cn(defaultClassNames, className)

  return (
    <input
      // Forward any remaining input props (onClick, disabled, aria-*, etc.).
      // Without this, an `onClick={e => e.stopPropagation()}` passed by a
      // caller is silently dropped — so a checkbox nested inside a clickable
      // row both toggles (onChange) AND bubbles to the row handler, double-
      // toggling and appearing to do nothing.
      {...rest}
      type="checkbox"
      className={cx}
      checked={checked}
      onChange={onChange}
    />
  )
}
